import { render, staticRenderFns } from "./WalletStash.vue?vue&type=template&id=3af959fa&"
import script from "./WalletStash.vue?vue&type=script&lang=js&"
export * from "./WalletStash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports